<template>
  <card>
    <h4 slot="header" class="card-title">Yeni İşletme</h4>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      >
      <a-form-model-item ref="corporation_name" label="İşletme Adı" prop="corporation_name">
        <a-input
          placeholder="İşletme Adı"
          v-model="form.corporation_name"
          @blur="
            () => {
              $refs.corporation_name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="owner_name" label="İşletme Sahibi Adı" prop="owner_name">
        <a-input
          placeholder="İşletme Sahibi Adı"
          v-model="form.owner_name"
          @blur="
            () => {
              $refs.owner_name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="phone_number" label="Telefon Numarası" prop="phone_number">
        <a-input
          placeholder="Telefon Numarası"
          v-model="form.phone_number"
          @blur="
            () => {
              $refs.phone_number.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="address" label="Adres" prop="address">
        <a-textarea
          v-model="form.address"
          placeholder="Adres"
        />
      </a-form-model-item>
      <a-form-model-item ref="description" label="Detay" prop="description">
        <a-textarea
          v-model="form.description"
          placeholder="Detay"
        />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Kumbara Atama" prop="moneybox_assignment">
        <a-select
          show-search
          label-in-value
          option-filter-prop="children"
          mode="multiple"
          style="width: 100%"
          placeholder="Kumbara seçiniz"
          :filter-option="filterOption"
          @focus="handleFocus"
          @blur="handleBlur"
          @change="handleChange"
        >
          <a-select-option v-for="d in moneyboxList" :value="d.value" v-key="d.value">
            {{d.text}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Oluştur
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>
<script>
  import { mapState } from "vuex"
  import Card from 'src/components/Cards/Card.vue'

  export default {
    mounted(){
      const self = this
      self.$store.dispatch("Moneybox/requestMoneyboxList")
    },
    components: {
      Card
    },
    computed: {
      ...mapState({
        moneyboxes: state => state.Moneybox.moneyboxes
      }),
      moneyboxList(){
        if(!this.moneyboxes.moneyboxes)return []
        return this.moneyboxes.moneyboxes.map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
      }
    },
    data () {
      return {
        selected_moneyboxes:[],
        loading: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 10 },
        form: {
          corporation_name: '',
          owner_name: '',
          phone_number: '',
          address: '',
          description: '',
        },
        rules: {
          corporation_name: [
            { required: true, message: 'İşletme Adı alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 50, message: 'İşletme Adı alanı min 3, max 50 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          owner_name: [
            { required: true, message: 'İşletme Sahibi Adı alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 50, message: 'İşletme Sahibi Adı alanı min 3, max 50 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          phone_number: [
            { required: false, trigger: 'blur' },
            { max: 50, message: 'Telefon numarası alanı max 50 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          address: [
            { required: true, message: 'Adres alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 200, message: 'Adres alanı min 3, max 200 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          description: [
            { required: false, message: 'Detay alanını boş bırakmayınız', trigger: 'blur' },
            { max: 500, message: 'Detay alanı max 500 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      handleChange(value) {
        this.selected_moneyboxes = value
      },
      handleBlur() {
        console.log('blur');
      },
      handleFocus() {
        console.log('focus');
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      onSubmit() {
        const self = this
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            self.loading = true
            self.$store.dispatch("Corporation/requestCorporationCreate", self.form).then((corporation)=> {
              self.$notification['success']({
                message: 'İşletme Ekleme',
                description:
                  'İşletme başarılı bir şekilde oluşturuldu :)',
              });
              if(self.selected_moneyboxes.length){
                self.$store.dispatch("Corporation/requestCorporationMoneyboxAssignmentCreate", {
                  corporation_id: corporation.id,
                  selected_moneyboxes: self.selected_moneyboxes
                })
              }
              self.$router.push('/admin/corporations/')
            }).catch(()=> {
              self.$notification['error']({
                message: 'İşletme Ekleme',
                description:
                  'İşletme eklenirken bir hata oluştu :/',
              });
            }).finally(()=> {
              self.loading = false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm() {
        this.$refs.ruleForm.resetFields();
      }      
    }
  }
</script>
<style>

</style>
